// User
export const SET_MPX_USER_INFO = "SET_MPX_USER_INFO"
export const SET_CABLE_USER_INFO = "SET_CABLE_USER_INFO"
export const SET_OPSUI_AUTHORIZE_INFO = "SET_OPSUI_AUTHORIZE_INFO"
export const SET_MVATS_AUTHORIZE_INFO = "SET_MVATS_AUTHORIZE_INFO"
export const SET_MPX_PARENT_ACCOUNT = "SET_MPX_PARENT_ACCOUNT"
export const SET_SERVICE_REGISTRY = "SET_SERVICE_REGISTRY"
export const SET_MPX_SUB_ACCOUNTS = "SET_MPX_SUB_ACCOUNTS"

// Providers, Provider Groups
export const SET_PROVIDERS = "SET_PROVIDERS"
export const SET_RPVODER_GROUPS = "SET_PROVIDER_GROUPS"

// Rules
export const SET_RULE_QUICK_VIEW = "SET_RULE_QUICK_VIEW"
export const SET_RULESET_RULES = "SET_RULESET_RULES"
export const SET_RULECOLLECTION_RULESETS = "SET_RULECOLLECTION_RULESETS"
export const SET_ADD_RULES_FILTERS = "SET_ADD_RULES_FILTERS"
export const SET_ADD_RULE_SETS_FILTERS = "SET_ADD_RULE_SETS_FILTERS"

// XPATH
export const SET_XPATH_MAPPINGS = "SET_XPATH_MAPPINGS"
export const SET_XPATH_MAPPINGS_LIST = "SET_XPATH_MAPPINGS_LIST"
export const SET_XPATH_MAPPINGS_LIST_LOADING = "SET_XPATH_MAPPINGS_LIST_LOADING"
export const SET_XPATH_MAPPING_KEYS = "SET_XPATH_MAPPING_KEYS"
export const SET_XPATH_MAPPING_KEYS_LOADING = "SET_XPATH_MAPPING_KEYS_LOADING"
export const SET_SELECTED_XPATH_KEY = "SET_SELECTED_XPATH_KEY"
export const SET_SHOW_XPATH_DETAILS = "SET_SHOW_XPATH_DETAILS"



// Config Service
export const SET_CONFIG_DETAILS_SIDE_SHEET = "SET_CONFIG_DETAILS_SIDE_SHEET"
export const SET_GROUPS_LIST = "SET_GROUPS_LIST"
export const SET_SELECTED_KEY = "SET_SELECTED_KEY"
export const SET_SELECTED_GROUP = "SET_SELECTED_GROUP"
export const SET_DETAILS_LOADING = "SET_DETAILS_LOADING"
export const SET_KEY_VALUE_DETAILS = "SET_KEY_VALUE_DETAILS"
export const SET_IS_EDIT_MODE = "SET_IS_EDIT_MODE"
export const SET_KEY_VALUE_DETAILS_RETRIEVED =
  "SET_KEY_VALUE_DETAILS_RETRIEVED"
export const SET_CONFIG_ERROR = "SET_CONFIG_ERROR"
export const SET_LOADING_GROUPS = "SET_LOADING_GROUPS"
export const SET_KEYS_LIST = "SET_KEYS_LIST"



// WEBPACK FOOTER //
// ./src/store/constants/mutation-types.js